import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function index({ selectedDevice, refreshList, notification, handleClose }) {
  const orgId = JSON.parse(localStorage.user).organization.id;
  const { userId } = JSON.parse(localStorage.user).user;
  const formModel = {
    deviceId: selectedDevice,
    tu_type: '',
    trackedId: '',
    projectId: '',
    organizationId: orgId,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getProject] = useApi();
  const [state2, getDevice] = useApi();
  const [projects, setProjects] = useState([]);
  const [device, setDevices] = useState([]);
  const [type, setType] = useState(['UNIT', 'BOX', 'PALLET', 'CONTAINER']);

  useEffect(() => {
    getProject(`/organization/${orgId}/projects`, 'GET');
    getDevice(`/organization/${orgId}/devices`, 'GET');
  }, []);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setProjects(state.data.projects);
    }
    if (state.isError) {
      notification('error', 'Unable to fetch projects detail');
    }
  }, [state]);

  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data) {
      const deviceArray = state2.data.devices.filter((data) => {
        if (!data?.device?.isActive && !data?.isActive) {
          if (
            data?.deviceType === 'BLE_TAG' ||
            data?.device?.deviceType === 'BLE_TAG' ||
            data?.deviceType === 'CATM1_TAG' ||
            data?.device?.deviceType === 'CATM1_TAG'
          ) {
            return data;
          }
        }
      });
      setDevices(deviceArray);
    }

    if (state2.isError) {
      notification('error', 'Unable to fetch projects detail');
    }
  }, [state2]);

  useEffect(() => {}, [formData]);

  const getId = (name) => {
    const project = projects.filter((item) => item.projectName === name);
    return project[0].id;
  };

  const getShippingInfoId = (name) => {
    const project = projects.filter((item) => item.projectName === name);
    return project[0].shippingInfoId;
  };

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      ...formData,
      projectId: getId(formData.projectId),
      shippingInfoId: getShippingInfoId(formData.projectId),
    };
    postData(`/device/${formData.deviceId}/asset`, 'POST', body);
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('sucess', 'Attach Asset Successfully');
      handleClose();
      refreshList(true);
    }

    if (isError) {
      handleClose();
      notification('error', 'Unable to Attach Asset');
    }
  }, [isLoading, isError, data]);

  return (
    <div
    className="flex justify-center items-center h-full w-full z-20 fixed"
    style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
  >
    <div className={`bg-white w-2/4 px-5 pt-4 relative rounded-2xl`}>
      <img
        src="assets/img/Close.svg"
        className="absolute top-3 right-3 h-3 cursor-pointer"
        alt=""
        onClick={handleClose}
      />
        <p className="font-bold text-sm text-textBlue1 border-b p-4">Attach Asset</p>
        <form className="mt-6 mb-2 mx-10 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
        <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="company" className="block text-parameter w-1/3 text-sm mr-2">
              DEVICE ID
            </label> */}
            <input
              type="text"
              placeholder="Device Id"
              value={formData.deviceId}
              autoComplete="off"
              name="deviceId"
              list="deviceId"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
            <datalist id="deviceId">
              {device.map((item) => (
                <option key={item?.device ? item?.device?.id : item?.id}>
                  {item?.device ? item?.device?.id : item?.id}
                </option>
              ))}
            </datalist>
          </div>

          <div className="w-1/10" />

          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
              ASSET ID
            </label> */}
            <input
              type="text"
              placeholder="Asset Id"
              name="trackedId"
              value={formData.trackedId}
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>

          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
              ASSET TYPE
            </label> */}
            <input
              type="text"
              placeholder="Asset Type"
              name="tu_type"
              list="tu_type"
              autoComplete="off"
              value={formData.tu_type}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
            <datalist id="tu_type">
              {type.map((item, idx) => (
                <option key={idx}>{item}</option>
              ))}
            </datalist>
          </div>
          <div className="w-1/10" />
          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
              PROJECT
            </label> */}
            <input
              type="text"
              placeholder="Project"
              list="projectId"
              name="projectId"
              autoComplete="off"
              value={formData.projectId}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
            <datalist id="projectId">
              {projects.map((item) => (
                <option key={item?.id}>{item?.projectName}</option>
              ))}
            </datalist>
          </div>
          <div className="w-7/12 mt-5 mb-2" />

        <div className="w-5/12 mt-5 mb-2 relative -right-8">
            {isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-48 mx-auto top-48" alt="" />
            ) : (
              <div className="flex text-xs">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer "
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl focus:outline-none w-1/2 h-10 text-white bg-primary cursor-pointer "
                  style={{ border: '1px solid #16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default index;